export default function Button({ text, color = "primary", type = "submit", className = "", onClick, disabled = false, loading = false, ...props }) {
  const colors = {
    primary: "bg-blue-700 hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700",
    success: "bg-emerald-700 hover:bg-emerald-800 dark:bg-emerald-600 dark:hover:bg-emerald-700",
    danger: "bg-red-700 hover:bg-red-800 dark:bg-red-600 dark:hover:bg-red-700",
  };
  return (
    <button {...props} type={type} onClick={onClick} disabled={disabled || loading} aria-busy={loading || undefined} className={`admin-button text-white ${colors[color] || colors.primary} text-sm w-full sm:w-auto px-6 py-2.5 text-center disabled:opacity-60 disabled:cursor-not-allowed ${className}`}>
      {loading ? "در حال ذخیره…" : text}
    </button>
  );
}
